var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectPulpBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1774",
    "data-name": "Group 1774",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.02,
    height: 59.374,
    viewBox: "0 0 70.02 59.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    width: 70.02,
    height: 59.374,
    fill: "#2a77eb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M0,137.735v-1.5a2.518,2.518,0,0,1,1.581-1.359,36.035,36.035,0,0,1,5.465-.012c2.387.287,2.339,3.965,0,4.246a36.035,36.035,0,0,1-5.465-.012A2.518,2.518,0,0,1,0,137.735",
    transform: "translate(0 -116.332)",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M456.337,136.231v1.5a2.518,2.518,0,0,1-1.581,1.359,36.035,36.035,0,0,1-5.465.012c-2.339-.281-2.387-3.959,0-4.246a36.035,36.035,0,0,1,5.465.012,2.518,2.518,0,0,1,1.581,1.359",
    transform: "translate(-386.316 -116.332)",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M125.314,47.8H113.825a9.714,9.714,0,0,0-3.84-7.716c-3.464-2.634-5.7-3.588-8.2-7.531C91.542,16.389,106.333-3.919,124.8.655c16.141,4,21.362,24.784,9.07,36.068-2.456,2.254-5.441,3.191-7.207,6.2a9.018,9.018,0,0,0-1.344,4.879m-15.49-37.713a1.948,1.948,0,0,0-1.252.8c-1.646,2.846-4.492,5.644-6.018,8.479a2.069,2.069,0,0,0-.141,2.306c2.213,2.56,4,6.229,6.218,8.688a2.049,2.049,0,0,0,3.256-.02c.9-1.262.281-2.016-.412-3.1-1.441-2.246-3.3-4.351-4.74-6.614,1.4-2.323,3.282-4.43,4.74-6.7a4.737,4.737,0,0,0,.784-1.4,2.036,2.036,0,0,0-2.436-2.437m12.17,0a2.061,2.061,0,0,0-1.471,1.264l-5.815,17.159a2.062,2.062,0,0,0,3.867,1.407l5.855-17.256a2.053,2.053,0,0,0-2.436-2.574m6.428,0a2.048,2.048,0,0,0-1.438,2.743l5.419,7.712c-1.694,2.8-3.954,5.25-5.526,8.106a2.051,2.051,0,0,0,3.629,1.713c2.224-2.348,4.024-6.193,6.219-8.688a2.012,2.012,0,0,0,0-2.173c-1.482-2.849-4.6-5.8-6.218-8.689a2.117,2.117,0,0,0-2.085-.723",
    transform: "translate(-84.97 0)",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M222.488,379.5v6.086c0,.745-.9,1.242-1.566,1.306-2.712.263-5.855-.2-8.614-.016a1.683,1.683,0,0,1-1.308-1.29V379.5Z",
    transform: "translate(-182.144 -327.6)",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M24.171,6.874a2.432,2.432,0,0,1,1.539.575A43.594,43.594,0,0,1,30.371,11.4a2.186,2.186,0,0,1-2.694,3.378,32.677,32.677,0,0,1-3.6-2.966C22.913,10.783,21.445,9.9,22.28,8.1a2.137,2.137,0,0,1,1.892-1.224",
    transform: "translate(-19.021 -5.933)",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M431.407,6.874a2.122,2.122,0,0,1,1.936,1.136c.953,1.821-.566,2.756-1.75,3.806a32.652,32.652,0,0,1-3.6,2.966A2.186,2.186,0,0,1,425.3,11.4a43.606,43.606,0,0,1,4.661-3.955,2.455,2.455,0,0,1,1.446-.575",
    transform: "translate(-366.63 -5.934)",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M426.537,235.37a2.257,2.257,0,0,1,1.8.318,48.067,48.067,0,0,1,5.071,4.366,2.192,2.192,0,0,1-2.7,3.245l-5.172-4.265a2.191,2.191,0,0,1,.995-3.664",
    transform: "translate(-366.809 -203.13)",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M28.016,235.342a2.178,2.178,0,0,1,2.34,3.433l-5.35,4.5a2.2,2.2,0,0,1-2.759-3.169,36.089,36.089,0,0,1,4.373-3.832,4.725,4.725,0,0,1,1.4-.929",
    transform: "translate(-18.891 -203.104)",
    fill: "#2a77eb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectPulpBlue);
export default __webpack_public_path__ + "static/media/project-pulp-blue.a4a65fe7d89370aff6c4145bda04ef48.svg";
export { ForwardRef as ReactComponent };